<template>
  <el-footer  class="footer" style="height: 30px;">
    <p class="copyRight"> 粤ICP备18028829号 Copyright © 2018 广州启橙网络技术科技有限公司 版权所有</p>
  </el-footer>
</template>

<script>
    export default {
        name: "QC_Footer",
        data() {
            return {}
        },
        methods: {},
        mounted() {
        }
    }
</script>


<style lang="less" scoped>
  .footer {
    height: 30px;
    color: #ffffff;
    width: 100%;
    font-size: 14px;
    line-height: 30px;
    background-color: #0072D2;;
    position: fixed;
    bottom: 0;
    text-align: center;
  }
  .footer>p{
    margin: 0px;
  }

</style>
